import React from 'react';
import '../styles/PublicPages.css';
import extensionIcon from '../assets/icons/extension.svg';
import extensionContentIcon from '../assets/icons/extension-content.svg';
import toggleSwitchIcon from '../assets/icons/toggle-switch.svg';
import safariInstructionGif from '../assets/safari_instruction.gif';

const DoneIcon = () => (
  <svg
    className="extension-done-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="9" cy="9" r="9" fill="#007AFF" />
    <path
      d="M5 9.2L7.6 11.8L13 6.4"
      stroke="#FFFFFF"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExtensionDownload = () => {
  return (
    <div className="extension-page">
      <div className="extension-page-inner">
        <div className="extension-gif-card">
          <img
            src={safariInstructionGif}
            alt="How to enable HomeCrowd in Safari"
            className="extension-gif"
          />
        </div>

        <div className="extension-instructions">
          <div className="instruction-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <p className="step-text">Open Safari Browser</p>
            </div>
          </div>

          <div className="instruction-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <p className="step-text">
                Tap the{' '}
                <img
                  src={extensionContentIcon}
                  alt=""
                  className="puzzle-piece-icon"
                />{' '}
                icon in the address bar
              </p>
            </div>
          </div>

          <div className="instruction-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <p className="step-text">
                Tap the{' '}
                <img
                  src={extensionIcon}
                  alt=""
                  className="extension-diamond-icon"
                />{' '}
                <strong>Manage Extensions</strong> option
              </p>
            </div>
          </div>

          <div className="instruction-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <p className="step-text">
                Toggle on the{' '}
                <img
                  src={toggleSwitchIcon}
                  alt=""
                  className="toggle-switch-icon"
                />{' '}
                next to HomeCrowd
              </p>
            </div>
          </div>

          <div className="instruction-step">
            <div className="step-number">5</div>
            <div className="step-content">
              <p className="step-text">
                Tap Done <DoneIcon /> to save
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtensionDownload;
